import React, { ReactNode } from "react";

interface SectionContainerProps {
  title?: string; // Optional title for the header
  children: ReactNode; // To render content inside the container
}

export const SectionContainer: React.FC<SectionContainerProps> = ({
  title = "Header",
  children,
}) => {
  return (
    <div className="w-full px-6 py-4">
      {" "}
      {/* py-4 adds some vertical space */}
      {/* Main container: white background, rounded corners, shadow optional */}
      <div className="bg-white rounded-3xl shadow-md overflow-hidden mx-auto">
        {" "}
        {/* rounded-3xl is 1.5rem, close to 2em. mx-auto for centering if parent allows */}
        {/* Header Section */}
        <div className="bg-perle-red text-white p-4">
          {" "}
          {/* Using theme color */}
          <h2 className="text-lg font-semibold">{title}</h2>{" "}
          {/* Displaying the title */}
        </div>
        {/* Content Area */}
        <div className="p-6">
          {" "}
          {/* Padding for the content area */}
          {children} {/* Render content passed to the component */}
        </div>
      </div>
    </div>
  );
};
